<!--讲解任务-->
<template>
  <div class="pm50">
    <div class="pd jhnstop row">
      <p class="col">
        <img src="../assets/img/logo.png" class="loginnhjer cz" />
      </p>
      <span class="cf fz15" @click="toHome">首页</span>
    </div>
    <div>
      <van-dropdown-menu>
        <van-dropdown-item v-model="queryInput.eDate" :options="option1" />
        <van-dropdown-item v-model="queryInput.customerRegTypeId" :options="customerRegTypes" />
      </van-dropdown-menu>
    </div>
    
    <no-data v-if="dataLoaded&&orders.length===0" :content-height="contentHeight"></no-data>
    <van-list  v-else class="pd dataDiv pm15" v-model="loading" :finished="finished"  @load="onLoad">
      <div class="pd sdfsdtywer mt15 pm15" v-for="(order,index) in orders" :key="index" >
        <div class="fz16 z3 row pt10">
          <p class="col">{{order.customerName}}</p>
          <span class="zts">{{getStatusName(order)}}</span>
        </div>
        <div class="jjnmmnxer mt10 pt10">
          
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">讲解日期 </span>
            </span>
            <span class="ml10 fz14 z6">{{order.travelDate}}</span>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">讲解时段</span>
            </span>
            <span class="ml10 fz14 z6">{{order.sTime}}-{{order.eTime}}</span>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">讲解区域</span>
            </span>
            <span class="ml10 fz14 z6">{{order.ticektTypeName}}</span>
          </div>
          <!-- <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">讲解员</span>
            </span>
            <span class="ml10 fz14 z6">{{order.explainerName}}</span>
          </div>           -->
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">人 数</span>
            </span>
            <span class="ml10 fz14 z6">{{order.totalNum}}</span>
          </div>
          <!-- <div v-if="order.plateNumbers && order.plateNumbers.length>0" >
            <div class="mt10" v-for="(plateNumber, index) in order.plateNumbers" :key="index">
              <span class="pr f_b">
                <i class="f_i binknxerrt"></i>
                <span class="kkmnmxerert">车牌号{{index+1}}</span>
              </span>
              <span class="ml10 fz14 z6">{{ plateNumber.licensePlateNumber }} {{ plateNumber.carTypeName }}</span>
            </div>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">联系人</span>
            </span>
            <span class="ml10 fz14 z6">{{order.ydrName}}</span>
          </div>

          <div class="mt10 row">
            <div class="col">
              <span class="pr f_b">
                <i class="f_i binknxerrt"></i>
                <span class="kkmnmxerert">手机号码</span>
              </span>
              <span class="ml10 fz14 z6">{{order.mobile}}</span>
            </div>           
          </div> -->
        </div>
      </div>
    </van-list>
    
  </div>
</template>
<script>

import moment from "moment";
import NoData from "@/components/NoData.vue";
import orderService from "@/services/orderService.js";

export default {

  data() {
    return {
      loading: false,
      dataLoaded: false,
      currentIndex: -1,
      customerName: "",
      finished: false,
      orders: [],   
      queryInput: {
        skipCount: 0,
        maxResultCount: 20,
        sDate: moment().format("YYYY-MM-DD"),
        eDate: moment().add(2, "days").format("YYYY-MM-DD"),
        customerRegTypeId:''
      },
      option1: [
        {
          text: "最近三天",
          value: moment().add(2, "days").format("YYYY-MM-DD")
        },
        // {
        //   text: "最近一周",
        //   value: moment()
        //   .subtract(1, "weeks")
        //   .format("YYYY-MM-DD")
        // },
        {
          text: "最近一个月",
          value: moment().add(1, "months").subtract(1, "days").format("YYYY-MM-DD"),
        },
        {
          text: "最近三个月",
          value: moment().add(3, "months").subtract(1, "days").format("YYYY-MM-DD"),
        },
      ],
      customerRegTypes: [
        {
          text: "全部",
          value: ''
        },        
        {
          text: "内部接待",
          value: 4,
        },        
        {
          text: "普通团队",
          value: 2,
        }
      ],
    };
  },
  components: {
    NoData
  },
  computed: {
    contentHeight() {
      return this.$store.state.clientHeight - 90;
    }
  },
  watch: {
    "queryInput.eDate": async function () {
        this.queryInput.skipCount = 0;
        this.orders = [];
        await this.getOrders();
    },    
    "queryInput.customerRegTypeId": async function () {
        this.queryInput.skipCount = 0;
        this.orders = [];
        await this.getOrders();
    },
  },
  methods: {
    toHome() {
      this.$router.push("/");
    },
    async onLoad() {
      await this.getOrders();
    },
    async getOrders() {
        try {
            this.loading = true;
            this.dataLoaded = false;

            let result = await orderService.getOrdersForExplainAsync(
                this.queryInput
            );

            for (let i = 0; i < result.items.length; i++) {
            this.orders.push(result.items[i]);
            }

            this.queryInput.skipCount =
            this.queryInput.skipCount + result.items.length;
            this.finished = this.orders.length === result.totalCount;

        } catch (err) {
            return;
        } finally {
            this.loading = false;
            this.dataLoaded = true;
        }
    },
    
    getStatusName(order) {
      //0未入场1已入场2接待中3已接待4已取消
       if(order.statusID ==3)
       {
         return "已接待";
       }
       else
       {
          if(!order.isValid)
          {
              return "未到期";
          }
          else if(order.statusID ==0)
          {
            return "未入场";
          }
          else if(order.statusID ==1)
          {
            return "已入场";
          }
          else if(order.statusID ==2)
          {
            return "接待中";
          }
          else if(order.statusID ==4)
          {
            return "已取消";
          }
       }
    }
  },
  mounted() {
    let vm = this;
    window.onscroll = function () {
      let currentScrollTop = document.scrollingElement.scrollTop;
      if (currentScrollTop === 0 && vm.scrollTop > 1) {
        window.scrollTo(0, vm.scrollTop);
      } else {
        vm.scrollTop = currentScrollTop;
      }
    };
  },
  beforeDestroy() {

  }
};
</script>
<style scoped>
.dataDiv {
  overflow: auto;
  position: fixed;
  width: 100%;
  height: calc(100vh - 90px);
}
</style>
